import React, { useEffect, useState } from "react";
import "./Admin.css";
import AdminSidebar from "./comon/AdminSidebar";
import Header from "./comon/Header";
import {
    Card,
    CardBody,
    CardHeader,
    Table,
    Button,
    ButtonGroup,
    Input,
} from "reactstrap";
import {
    FaSearch,
    FaFileAlt,
    FaMapMarkerAlt,
    FaVideo,
    FaUsers,
} from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";


function UsersList() {
    const navigate = useNavigate();

    const [userList, setUserList] = useState([]);
    const [search, setSearch] = useState("");
    const [vitalCreated, setVitalCreated] = useState({});

    const loadUsers = () => {
        fetch("https://idverify.emphasispay.com/api/get-users.php", {
            method: "POST",
        })
            .then((res) => res.json())
            .then((result) => {
                setUserList(result.result || []);
            });
    };
    const handleVideoClick = (user) => {
        axios.post("https://idverify.emphasispay.com/api/vital-create-search.php?user_id=" + user.id)
            .then((res) => {
                console.log(res.data);
                if (res.data && (res.data.success || res.data.status === "created" || res.data.data)) {
                    setVitalCreated((prev) => ({ ...prev, [user.id]: true }));
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        loadUsers();
    }, []);

    const filterData = userList.filter(
        (item) =>
            item.fname?.toLowerCase().includes(search.toLowerCase()) ||
            item.email?.toLowerCase().includes(search.toLowerCase()) ||
            item.phone?.includes(search)
    );

    return (
        <div className="main-div">
            <AdminSidebar />

            <div className="fill-width">
                <Header />

                <div className="dashboard-container">

                    {/* Top Header */}
                    <div className="page-top-box">
                        <div>
                            <h2>Customer Management</h2>
                            <p>Manage all customer KYC records and documents.</p>
                        </div>

                        <div className="user-count-box">
                            <FaUsers />
                            <span>{userList.length} Users</span>
                        </div>
                    </div>

                    {/* Search */}
                    <div className="search-wrapper">
                        <FaSearch className="search-icon2" />
                        <Input
                            placeholder="Search by name, email, phone..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    {/* Table Card */}
                    <Card className="table-card">
                        <CardHeader className="table-header">
                            <h4>Customer Data List</h4>
                        </CardHeader>

                        <CardBody className="p-0">

                            <div className="table-responsive">
                                <Table className="modern-table" borderless hover>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Govt ID</th>
                                            <th>Address</th>
                                            <th>Video</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filterData.length > 0 ? (
                                            filterData.map((user, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>

                                                    <td>
                                                        <div className="table-user">
                                                            <div className="user-avatar">
                                                                {user.fname?.charAt(0)}
                                                            </div>
                                                            {user.fname}
                                                        </div>
                                                    </td>

                                                    <td>{user.email}</td>

                                                    <td>{user.phone}</td>

                                                    <td>
                                                        <Link
                                                            to={user.id_proof}
                                                            target="_blank"
                                                            className="doc-link"
                                                        >
                                                            <FaFileAlt /> Open
                                                        </Link>
                                                    </td>

                                                    <td>
                                                        <Link
                                                            to={user.adress_proof}
                                                            target="_blank"
                                                            className="doc-link"
                                                        >
                                                            <FaMapMarkerAlt /> Open
                                                        </Link>
                                                    </td>

                                                    <td>
                                                        {user.video_link ? (
                                                        <Link
                                                            to={`/admin/video-page/${user.key_data}`}
                                                            className="video-link"
                                                        >
                                                            <FaVideo /> View
                                                        </Link>
                                                        ) : (
                                                            <span className="no-video" style={{color:'red'}}>KYC Pending</span>
                                                        )}
                                                    </td>

                                                    <td style={{ minWidth: "220px" }} >
                                                        <ButtonGroup>
                                                            <Button
                                                                className="video-btn"
                                                                size="sm"
                                                                onClick={() =>
                                                                    navigate("/admin/user/" + user.key_data)
                                                                }
                                                            >
                                                                View
                                                            </Button>
                                                            {user.video_link ? (
                                                                vitalCreated[user.id] || user.vital_create_search || user.vital_created ? (
                                                                    <Button className="video-btn created" size="sm" disabled style={{background:'green !important'}}>
                                                                     Vital4
                                                                    </Button>
                                                                ) : (
                                                                    <Button className="video-btn" size="sm" onClick={() => handleVideoClick(user)}>
                                                                        Vital4
                                                                    </Button>
                                                                )
                                                            ) : null}
                                                        </ButtonGroup>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center p-4">
                                                    No Users Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default UsersList;